import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { defaultMemoize } from 'reselect';
import _get from 'lodash/get';
import _values from 'lodash/values';
import { EMPTY_ARRAY } from 'tbase/app.constants';
import Money from 'tbase/utils/money';
import { getRandomId, removeMatchedItems, formatCurrencyWithMoneyFormat, findArrayItem } from '../utils';
import { GROSS_TYPES, PAY_TYPE_VALUES } from '../constants/accessoriesUpdate.constants';
var CASH_DEFICIENCY_ACCESSORY_CODE = 'WE_OWE_CASHDEFICIENCY';
export var addItemToAccessories = function addItemToAccessories(accessories) {
  var newAccessories = _toConsumableArray(accessories);

  newAccessories.push(getEmptyAccessory());
  return newAccessories;
};

function getEmptyAccessory() {
  return {
    id: getRandomId(),
    // uniqueId: getRandomId(),
    code: undefined,
    taxable: true,
    payType: PAY_TYPE_VALUES.CUSTOMER_PAY,
    profitType: GROSS_TYPES.FRONT,
    deleted: false,
    disclosureType: 'OTHER'
  };
}

export var getAccessoryForCashDeficiency = function getAccessoryForCashDeficiency(value) {
  return {
    id: getRandomId(),
    uniqueId: getRandomId(),
    code: CASH_DEFICIENCY_ACCESSORY_CODE,
    taxable: true,
    payType: PAY_TYPE_VALUES.CUSTOMER_PAY,
    profitType: GROSS_TYPES.FRONT,
    deleted: false,
    disclosureType: 'OTHER',
    cost: 0,
    price: value,
    name: 'Up Front Fees'
  };
};
export var getCashDeficiencyAccessory = function getCashDeficiencyAccessory() {
  var accessories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_ARRAY;
  return accessories.find(function (_ref) {
    var code = _ref.code;
    return code === CASH_DEFICIENCY_ACCESSORY_CODE;
  });
};
export function getCashDeficiencyAccessoryAmount() {
  var accessories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_ARRAY;
  var cashDeficiencyAccessory = getCashDeficiencyAccessory(accessories);
  return _get(cashDeficiencyAccessory, ['price']) || 0;
}
export function removeCashDeficiencyAccessory(accessories) {
  var newAccessories = _toConsumableArray(accessories);

  var matchingIndex = accessories.findIndex(function (_ref2) {
    var code = _ref2.code;
    return code === CASH_DEFICIENCY_ACCESSORY_CODE;
  });

  if (matchingIndex >= 0) {
    newAccessories.splice(matchingIndex, 1);
  }

  return newAccessories;
}
export var deleteItemFromAccessories = function deleteItemFromAccessories() {
  var accessories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_ARRAY;
  var id = arguments.length > 1 ? arguments[1] : undefined;
  return removeMatchedItems(accessories, 'id', id);
};
export var getUpdatedAccessoryItem = function getUpdatedAccessoryItem(accessories, id, key, value) {
  return accessories.map(function (item) {
    if (item.id === id) {
      return _objectSpread(_objectSpread({}, item), {}, _defineProperty({}, key, value));
    }

    return item;
  });
};
export var getAccessoriesAccordianData = defaultMemoize(function (accessories) {
  var total = 0;
  var accessoriesAccordianData = accessories.map(function (accessory) {
    var name = accessory.name,
        price = accessory.price;
    total = Money.add(total, Number(price));
    return {
      value: formatCurrencyWithMoneyFormat(price),
      name: name,
      id: getRandomId()
    };
  });
  return {
    accessoriesAccordianData: accessoriesAccordianData,
    total: formatCurrencyWithMoneyFormat(total)
  };
});
export var resetItemData = function resetItemData(accessories, id) {
  return accessories.map(function (item) {
    if (item.id === id) {
      return _objectSpread(_objectSpread({}, item), {}, {
        code: undefined,
        cost: undefined,
        price: undefined,
        taxable: true,
        payType: PAY_TYPE_VALUES.CUSTOMER_PAY,
        profitType: GROSS_TYPES.FRONT,
        deleted: false,
        disclosureType: 'OTHER'
      });
    }

    return item;
  });
};
export function removeUnwantedAccessories(accessories) {
  return accessories.filter(function (accessory) {
    var code = _get(accessory, 'code');

    var name = _get(accessory, 'name');

    var price = _get(accessory, 'price');

    var cost = _get(accessory, 'cost');

    if (code || name || price || cost) {
      return true;
    }

    return false;
  });
}
export function getEquipmentRecap(_ref3) {
  var marketScanData = _ref3.marketScanData,
      columnId = _ref3.columnId,
      equipmentId = _ref3.equipmentId;
  var downpaymentValues = _get(marketScanData, [columnId]) || {};

  var values = _values(downpaymentValues);

  var vehicleEquipmentItems = _get(values, '0.FullDetails.EquipmentRecap.Items') || [];
  var neededEquipment = findArrayItem(vehicleEquipmentItems, 'ID', equipmentId) || {};
  return neededEquipment;
}